import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { IconNotification } from 'src/components/Icons/Notification';
import { IconNotificationActive } from 'src/components/Icons/NotificationActive';
import { UserModel } from 'src/models/Account/User';
import { resources } from 'src/config/resources';
import { commonSelector } from 'src/store/commonPart/selector';
import useScriptInvoked from '../../utils/hooks/useScriptInvoked';

type NotificationProps = {
  user: UserModel;
};

const beamerScriptUrl = resources.beamer.scriptUrl;

export const HeaderNotifications: React.FC<NotificationProps> = ({ user }: NotificationProps) => {
  const beamerConfig = useSelector(commonSelector).configuration.response?.externalServices.beamer;
  useMemo(() => {
    window.beamer_config = {
      product_id: beamerConfig?.productId || null,
      selector: '.beamer-button-target',
      user_firstname: user.firstName,
      user_lastname: user.lastName,
      user_email: user.email,
      user_id: user.id,
      bounce: beamerConfig?.bounce || false,
    };
  }, [beamerConfig, user]);

  useScriptInvoked(beamerScriptUrl);

  const beamerButtonRef = useRef<HTMLAnchorElement>(null);

  const [isNotificationActive, setIsNotificationActive] = useState(false);

  useEffect(() => {
    let obs: MutationObserver;
    if (beamerButtonRef.current) {
      obs = new MutationObserver((mutationList) => {
        const children = [...(mutationList[0].target as HTMLAnchorElement).children];
        // check exists active beamer-icon
        const isExistsNotifications = children.some((item) => item.classList.contains('active'));
        if (isExistsNotifications !== isNotificationActive) {
          setIsNotificationActive(isExistsNotifications);
        }
      });
      obs.observe(beamerButtonRef.current, { childList: true });
    }
    return () => {
      if (obs) {
        obs.disconnect();
      }
    };
  }, [isNotificationActive]);

  return (
    <li className="beamer-button-container hidden-xs">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        ref={beamerButtonRef}
        className="beamer-button transparent notifications-button beamer-button-target no-box-shadow"
        data-test="beamer"
      >
        {isNotificationActive ? <IconNotificationActive /> : <IconNotification />}
      </a>
    </li>
  );
};
